import { ISelectItem } from "@aecom/core";
import { Injectable, inject } from "@angular/core";
import { rfiAppId } from "@shared/staticValue";
import { IUser, TPContractUser } from "../api-generated";
import BaseService from "./base.service";
import LocalUserService from "./local-user.service";

@Injectable({
  providedIn: "root",
})
export default class LocalContractUserService extends BaseService<TPContractUser> {
  localUserService = inject(LocalUserService);

  public currentUserContractRole: string;

  public defaultDoc: string | null;

  public getUsers(
    userTypes: string[] = [],
    excludeUserTypes: string[] = [],
  ): TPContractUser[] {
    return this.itemsSubject
      .getValue()
      .filter((user: TPContractUser) => {
        const cuar = user.contract_user_application_role.find((ar)=>{return ar.ApplicationId === rfiAppId});
        const roleId = cuar?.ApplicationRoleId;
        return roleId ? (!excludeUserTypes.includes(roleId) && (userTypes.length === 0 || userTypes.includes(roleId))) : false;
      });
  }

  public getUser(userId: string): TPContractUser | undefined {
    return this.getUsers().find((user) => {
      return user.UserId == userId;
    });
  }
  public getContractUserInfo(userId: string): IUser | undefined {
    const user = this.getUsers().find((user) => {
      return user.UserId == userId;
    });
    if(!user)
    {
      return undefined;
    }
    return this.localUserService.getUserById(userId);
  }

  public getUserInfo(userId: string): IUser | undefined {
    return this.localUserService.getUserById(userId);
  }

  public getUserRoleId(userId: string): string | undefined {
    const user = this.getUsers().find((user) => {
      return user.UserId == userId;
    });
    if(user)
    {
      const cuar = user.contract_user_application_role.find((ar)=>{return ar.ApplicationId === rfiAppId});
      return cuar?.ApplicationRoleId;
    }
    return undefined;
  }

  public getUserRole(userId: string): string | undefined {
    const user = this.getUsers().find((user) => {
      return user.UserId == userId;
    });
    if(user)
    {
      const cuar = user.contract_user_application_role.find((ar)=>{return ar.ApplicationId === rfiAppId});
      return cuar?.application_role.Role;
    }
    return undefined;
  }

  public getUsersDropDownByRoleIds(
    includeRoles: boolean,
    userTypes: string[] = [],
    excludeUserTypes: string[] = [],
  ): ISelectItem[] {
    return this.getUsers(userTypes, excludeUserTypes).flatMap((cu)=>{
      const user = this.localUserService.getUserById(cu.UserId);
      if(!user || !user.displayName)
      {
        return [];
      }
      let name = `${user.displayName}`;
      if(includeRoles)
      {
        const role = cu.contract_user_application_role.find((ar)=>{return ar.ApplicationId === rfiAppId})?.application_role.Role;
        if(role)
        {
          name += ` (${role ?? ""})`;
        }
      }
      return [{
        id: cu.UserId,
        name: name,
        checked: false,
      }];
    }).sort((a, b)=>a.name.localeCompare(b.name));
  }
}
